<template>
  <router-view />
</template>

<script>
import request from "@/utils/request";
import socket from "@/utils/socket";
export default {
  created() {
    this.getSocketUrl();
  },
  mounted() {
    const role = localStorage.getItem("vce-token-push");
    if (role) {
      socket.initWebpack();
    }
  },
  methods: {
    async getSocketUrl() {
      const res = await request.post("/api/common/getSocketUrl");
      localStorage.setItem("socketUrl", res.data.socketUrl);
    },
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>
